import axios from 'axios';
import moment from 'moment';
import { constructServiceURL } from '../../../../../../../utils/URLTools';

const apiFetchRepatriationsTransactionsExecute = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'executeRepatriationsTransactions',
    stub: process.env.useStubbedEndpoints,
    pathParameters: {
      appContext: payload.appContext.appContext,
    },
  });
  return axios.post(serviceUrl, {
    departureDateTime: moment(payload.params.departureDateTime).format('YYYY-MM-DD HH:mm:ss'),
    description: payload.params.description,
    plannedArrivalDateTime: moment(payload.params.plannedArrivalDateTime).format('YYYY-MM-DD HH:mm:ss'),
    quantity: payload.params.quantity,
    transactionId: payload.params.transactionId,
  });
};

export default apiFetchRepatriationsTransactionsExecute;
